<template>
  <div class="mb-8">
    <template v-if="Array.isArray(value)">
      <template v-for="(conditional, index) in value">
        <div class="och-field--conditional mb-4" :key="index">
          <p class="font-weight-bold mb-0">IF</p>
          <conditional-if
            :entityName="entityName"
            :conditional="conditional"
            :optionAttributeEntityName="optionAttributeEntityName"
            @update="conditional => update(conditional, index)"
          ></conditional-if>
          <div>
            <v-btn
              color="primary"
              outlined
              small
              @click="value.splice(index, 1)"
              >Remove Conditional</v-btn
            >
          </div>
        </div>
      </template>
    </template>

    <v-btn
      class="mt-1"
      color="primary"
      outlined
      @click="Array.isArray(value) ? value.push({}) : (value = [{}])"
      v-if="!(Array.isArray(value) && value.length)"
      >Add Filter</v-btn
    >
  </div>
</template>

<script>
import ConditionalIf from "./ConditionalIf";

import formElementMixin from "./formElementMixin";

export default {
  components: {
    ConditionalIf,
  },
  methods: {
    update(conditional, index) {
      this.$set(this.value, index, conditional);
    },
  },
  mixins: [formElementMixin],
  props: {
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
    entityName: {
      required: true,
    },
  },
};
</script>
